// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3k8uZ","label":"Category_label__3ssmN","content":"Category_content__2thf6","header":"Category_header__1c0xj","location":"Category_location__3XQGN"};